<template>
  <div>
    <v-layout wrap justify-center mt-12 v-show="!isShowingBookingSuccess">
      <v-flex xs12 sm10>
        <v-layout wrap>
          <v-flex xs12 text-center>
            <h1>{{ $t('a') }}</h1>
          </v-flex>
        </v-layout>
        <v-layout wrap mt-2 mb-2 justify-center>
          <v-flex xs12 text-center>
            <img :src="images.top" height="250px" class="mb-4"/>
          </v-flex>
          <v-flex xs8>
            <v-form>
              <v-card class="px-12 pt-3 pb-6">
                <v-layout text-xs-center justify-center row wrap>
                  <v-flex xs12 class="pt-4">
                    <h3>{{ $t('c') }}</h3>
                    <small>
                      <!-- {{ $t('d') }}<br> -->
                      {{ $t('e') }}
                    </small>
                  </v-flex>
                </v-layout>
                <v-layout v-if="showProgress" wrap>
                  <v-flex xs12 class="mt-4" text-center>
                    <progress id="uploader" value="0" max="100"></progress>
                  </v-flex>
                </v-layout>
                <v-layout v-else row wrap text-center justify-center class="pb-2">
                  <v-flex xs12 text-center>
                    <span v-if="error">{{ $t('f') }}</span>
                  </v-flex>
                  <v-flex xs12 text-center mt-8>
                    <div>
                      <div class="mb-6" v-if="dossierExamplesLength > 0">
                        <v-icon color="secondary">check</v-icon>
                      </div>
                      <v-btn class="upload-btn-wrapper" outlined>
                        <v-icon>mdi-file-outline</v-icon>
                        <span v-if="dossierExamplesLength > 0">{{ $t('g') }}</span>
                        <span v-else>{{ $t('h') }}</span>
                        <input id="fileButton" type="file" value="upload" accept=".doc,.docx"/>
                      </v-btn>
                      <div><small>{{ $t('i') }}</small></div>
                    </div>
                  </v-flex>
                  <v-flex xs12 text-center mt-8 v-if="expectedDossierExamplesLength === dossierExamplesLength">
                    <b v-if="dossierExamplesLength === 0">{{ $t('j') }}</b>
                    <b v-else-if="dossierExamplesLength === 1">{{ $t('k') }}</b>
                    <b v-else>{{dossierExamplesLength}} {{ $t('l') }}</b>
                    <div v-if="dossierExamplesLength > 0">
                      <small>{{ $t('m') }}</small>
                    </div>
                  </v-flex>
                  <v-flex xs4 v-else>
                    <v-progress-linear indeterminate color="primary" class="mt-4"></v-progress-linear>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
        <v-layout wrap mt-6 justify-center>
          <v-flex xs12 text-center mt-6 mb-12>
            <v-btn class="secondary" @click="isShowingBookingSuccess = true" :disabled="dossierExamplesLength === 0 ">{{ $t('n') }}</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>


    <v-layout wrap justify-center v-show="isShowingBookingSuccess" mt-12 pt-12>
      <v-flex xs12 text-center mt-12 pt-12>
        <div>
          <v-icon class="secondary--text" large>mdi-check</v-icon>
        </div>
        <div class="mt-6"><h4>{{ $t('success1') }}</h4></div>
        <div class="mt-3" v-if="assigned_to">
          {{ $t('success2') }} {{ assigned_to }}.
        </div>
        <div v-if="invitee_email">
          <b>{{ $t('success3') }} {{ invitee_email }}</b>
        </div>
        <div>
          <small>{{ $t('success4') }} <a href="mailto:martin@esnwebservices.com">martin@esnwebservices.com</a></small>
        </div>
        <div>
          <small>{{ $t('success5') }}</small>
        </div>
      </v-flex>
      <!-- <v-flex xs12 text-center class="mt-12 pt-6" v-if="$route.query.lang !== 'en'">
        <div>
          <v-icon class="secondary--text" large>mdi-share</v-icon>
        </div>
        <div><h4>{{ $t('presentation1') }}</h4></div>
        <div class="mt-2">
          <v-btn small @click="downloadPresentationFile" class="secondary">
            <v-icon small class="mr-2">mdi-download</v-icon>
            {{ $t('presentation2') }}
          </v-btn>
        </div>
      </v-flex> -->
      <v-flex xs12 text-center mt-6>
        <div>
          <img :src="images.bookingSuccess" height="250px">
        </div>
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    success: false,
    error: false,
    showProgress: false,
    dossierExamplesLength: 0,
    expectedDossierExamplesLength: 0,
    images: {
      top: require('@/assets/app/images/data_hosting_flatline.svg'),
      bookingSuccess: require('@/assets/app/images/Calendar_Flatline.svg'),
    },
    isShowingBookingSuccess: false
  }),
  computed: {
    assigned_to() {
      const str = decodeURIComponent(this.$route.query.assigned_to)
      return str !== 'undefined' ? str : null
    },
    invitee_email() {
      const str = decodeURIComponent(this.$route.query.invitee_email)
      return str !== 'undefined' ? str : null
    },
  },
  mounted() {
    this.initFileUploader()
  },
  methods: {
    initFileUploader() {
      const _this = this;
      const fileButton = document.getElementById('fileButton');

      fileButton.addEventListener('change', function(e) {
        _this.expectedDossierExamplesLength += 1
        _this.showProgress = true;
        _this.success = false;
        _this.error = false;

        // Get file
        const file = e.target.files[0];

        // Create a storage ref
        const userEmail = _this.invitee_email;
        const date = new Date().toISOString();
        const fileName = `${userEmail}--${date}`
        const tmpNameArr = fileButton.value.toString().split('.')
        const fileExtension = tmpNameArr[tmpNameArr.length - 1]
        const filePath = `dossierExamples/${fileName}.${fileExtension}`
        const storageRef = _this.$storage.ref(filePath);
        
        // Upload file
        const task = storageRef.put(file);

        // Update progress bar
        task.on('state_changed',
          function progress(snapshot) {
            const percentage = snapshot.totalBytes !== 0 ? Math.round(snapshot.bytesTransferred / snapshot.totalBytes * 100) : 0;
            const uploader = document.getElementById('uploader');
            uploader.value = percentage;
          },
          function error() {
            _this.error = true;
            _this.showProgress = false;
            _this.expectedDossierExamplesLength -= 1
          },
          function complete() {
            _this.success = true;
            _this.showProgress = false;
            _this.dossierExamplesLength += 1
            setTimeout(() => {
              _this.initFileUploader()
            }, 1)
          }
        )
      })
    },
    downloadPresentationFile() {
      this.haveUserDownloadFile('https://firebasestorage.googleapis.com/v0/b/esnwebservices-prod.appspot.com/o/public%2FESN%20Web%20Services%20-%20Pre%CC%81sentation.pdf?alt=media&token=929dac4b-9a7e-4899-a67e-770493c2cb03')
    },
    haveUserDownloadFile(url) {
      axios({
        method: 'get',
        url,
        responseType: 'arraybuffer',
      })
      .then((response) => {
        this.forceFileDownload(response)
      })
      .catch(() => console.log('error occured'))
    },
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.style.display = 'none';
      link.href = url
      link.setAttribute('download', 'ESN Web Services - Présentation.pdf')
      document.body.appendChild(link)
      link.click()
    },
  }
}

</script>


<i18n>
{
  "fr": {
    "a": "Comprendre le format de vos dossiers de compétences",
    "b": "Votre rdv est confirmé.",
    "c": "Pour préparer la démo, uploadez un exemple de dossier de compétences de votre ESN.",
    "d": "Nous en identifions la structure, les polices d'écriture, votre logo...",
    "e": "Cela nous permettra de créer des dossiers de compétences au format exact de votre ESN.",
    "f": "Erreur lors de l'upload.",
    "g": "Uploader un autre dossier",
    "h": "Uploader",
    "i": "Choisissez un fichier Word (.doc ou .docx)",
    "j": "0 dossier de compétences uploadé",
    "k": "1 dossier de compétences uploadé",
    "l": "dossiers de compétences uploadés",
    "m": "N'hésitez pas à en uploader plusieurs pour améliorer la qualité des dossiers générés.",
    "n": "Terminer",

    "success1": "Vidéoconférence confirmée",
    "success2": "Vous avez rendez-vous avec",
    "success3": "Une invitation a été envoyée à votre adresse email",
    "success4": "Pour toute question, contactez-nous à",
    "success5": "À bientôt !",

    "presentation1": "Partagez notre plaquette en interne",
    "presentation2": "Télécharger notre plaquette"
  },
  "en": {
    "a": "Understanding the layout of your company's CVs",
    "b": "Step 2 of 2",
    "c": "Upload an example of CV that you send to your clients.",
    "d": "We will extract their common formatting data : document structure, fonts, images...",
    "e": "It will enable the creation of new CVs with the exact same format.",
    "f": "An error occurred during the upload.",
    "g": "Upload another CV",
    "h": "Upload",
    "i": "Choose a Word document (.doc or .docx).",
    "j": "0 CV uploaded",
    "k": "1 CV uploaded",
    "l": "CVs uploaded",
    "l": "CVs uploaded",
    "m": "Feel free to upload multiple examples of CVs.",
    "n": "Finish",

    "success1": "Video conference confirmed",
    "success2": "You will be meeting",
    "success3": "An invitation has been sent to your email address",
    "success4": "For any question, please contact us at",
    "success5": "See you soon !",

    "presentation1": "Share our presenation internally",
    "presentation2": "Download our presentation"
  }
}
</i18n>